import React from "react";
import { Button, Dialog, DialogActions, DialogContent, Grow, Typography } from "@material-ui/core";
import ErrorOutlineOutlinedIcon from "@material-ui/icons/ErrorOutlineOutlined";
import BlockOutlinedIcon from "@material-ui/icons/BlockOutlined";
import PhoneInTalkIcon from "@material-ui/icons/PhoneInTalk";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import styles from "./Login.module.css";

// One component for both the real lockout screen (Login.js) and SuperAdmin's
// "Preview" button (SupportContactTab.js) - a preview rendered from separate
// markup would quietly stop matching the thing it claims to preview.

// Matches GlobalSettingsModel.js's own defaults, for the window between a
// fresh deploy and the settings document being readable.
export const FALLBACK_SUPPORT_NUMBER = "+91 94140 64844";

// tel:/wa.me want digits only, whatever spacing the admin typed.
const toDialable = (value) => String(value || "").replace(/\D/g, "");

const AccessExpiredDialog = ({
  open,
  onClose,
  message,
  businessName,
  callNumber,
  whatsappNumber,
}) => {
  const call = callNumber || FALLBACK_SUPPORT_NUMBER;
  const whatsapp = whatsappNumber || FALLBACK_SUPPORT_NUMBER;

  const whatsappText = encodeURIComponent(
    `Hello, I need help with my POS access.\n\nStore: ${
      businessName || "(not set)"
    }\nIssue: Access expired - I can't sign in.\n\nCould you please help me renew the subscription? Thank you.`
  );

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs" TransitionComponent={Grow}>
      <div className={`${styles.dialogHeader} ${styles.dialogHeaderDanger}`}>
        <ErrorOutlineOutlinedIcon />
        <Typography variant="h6" style={{ fontWeight: 700 }}>
          Access Expired
        </Typography>
      </div>

      <DialogContent className={`${styles.dialogBody} ${styles.expiredBody}`}>
        <div className={styles.expiredIconWrap}>
          <BlockOutlinedIcon className={styles.expiredIcon} />
        </div>
        <Typography className={styles.expiredLine} style={{ fontWeight: 700, color: "#1f2430" }}>
          This login is no longer active.
        </Typography>
        <Typography className={styles.expiredLine} style={{ color: "#64748b" }}>
          {message}
        </Typography>

        {/* One tap to actually reach someone, instead of leaving the user to
            copy a phone number out of a sentence by hand - they're locked out
            at exactly the moment they need help. */}
        <div className={styles.expiredActions}>
          <Button
            className={styles.callBtn}
            startIcon={<PhoneInTalkIcon />}
            href={`tel:+${toDialable(call)}`}
            disableElevation
            fullWidth
          >
            Call support
          </Button>
          <Button
            className={styles.whatsappBtn}
            startIcon={<WhatsAppIcon />}
            href={`https://wa.me/${toDialable(whatsapp)}?text=${whatsappText}`}
            target="_blank"
            rel="noopener noreferrer"
            disableElevation
            fullWidth
          >
            WhatsApp us
          </Button>
        </div>

        {call === whatsapp ? (
          <div className={styles.expiredPhone}>{call}</div>
        ) : (
          <div className={styles.expiredPhone}>
            <span>Call {call}</span>
            <span className={styles.expiredPhoneSep}>·</span>
            <span>WhatsApp {whatsapp}</span>
          </div>
        )}
      </DialogContent>

      <DialogActions className={styles.dialogActions} style={{ justifyContent: "center" }}>
        <Button onClick={onClose} className={styles.cancelBtn} disableElevation>
          Close
        </Button>
      </DialogActions>

      <div className={styles.expiredFooter}>Powered by Mindtree Technologies Co. Ltd.</div>
    </Dialog>
  );
};

export default AccessExpiredDialog;
